import Setup2FA from "../../components/Setup2FA";

const Setup2FAPage = () => {
    return <Setup2FA />;
};

export default Setup2FAPage;
